import type { AxiosResponse } from 'axios'
import type { QueryClient } from 'react-query'

import { zervantSettingsQueryKey } from '../../../constants/zervantSettingsQueryKey'
import type { ZervantSettings } from '../../../types/zervantSettings'
import { getPrimaryTradeName } from '../../../utils/getPrimaryTradeName'
import type { LogoAndBrandingSettingsFormValues } from '../types/logoAndBrandingSettingsFormValues'

// Takes the caller's useQueryClient() instance: tests render with their own client, not the app singleton.
export const getLogoAndBrandingSettingsCompanyPayload = (
  formData: LogoAndBrandingSettingsFormValues,
  queryClient: QueryClient,
) => {
  // tradeNames is replaced wholesale, so the company patch has to start from the cache at save time.
  const cachedSettingsResponse = queryClient.getQueryData<AxiosResponse<ZervantSettings>>(zervantSettingsQueryKey)

  if (!cachedSettingsResponse?.data) {
    throw new Error('Invoicing settings cache is empty')
  }

  const company = cachedSettingsResponse.data.values.company
  const primaryTradeName = getPrimaryTradeName(company.tradeNames)

  const tradeNames = company.tradeNames.map((tradeName) => {
    if (tradeName !== primaryTradeName) {
      return tradeName
    }

    const { logo, ...rest } = tradeName

    return {
      ...rest,
      // Include logo only if logoId is set;
      //  logoId is null after the logo is deleted
      ...(formData.logoId
        ? {
            logo: {
              id: formData.logoId,
              content: formData.logoUrl ?? undefined,
            },
          }
        : {}),
    }
  })

  return { ...company, tradeNames }
}
